import apiConfig from '../api-config';
const api_base_url = apiConfig.api_base_url;
const api_key = apiConfig.api_key;

export const getUrlResults = async (userId) => {
  try {
    const token = sessionStorage.getItem('authToken');
    const response = await fetch(`${api_base_url}/api/${api_key}/get/${userId}/url/urlResults`, {
      method: 'GET',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
    });
  
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || data.error || 'Failed to fetch URL reports');
    }

    if (!Array.isArray(data)) {
      throw new Error('Invalid URL report response');
    }

    return data;
  } catch (error) {
    console.error('Error fetching user url details:', error);
    throw error;
  }
};

export const getUrlScanJob = async (userId, jobId) => {
  try {
    const token = sessionStorage.getItem('authToken');
    const response = await fetch(
      `${api_base_url}/api/${api_key}/get/${userId}/url/scanJobs/${jobId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      }
    );

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || data.error || 'Failed to fetch scan progress');
    }
    return data;
  } catch (error) {
    console.error('Error fetching URL scan progress:', error);
    throw error;
  }
};

export const getActiveUrlScanJob = async (userId) => {
  try {
    const token = sessionStorage.getItem('authToken');
    const response = await fetch(
      `${api_base_url}/api/${api_key}/get/${userId}/url/scanJobs/active`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      }
    );
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || data.error || 'Failed to fetch the active scan');
    }
    return data;
  } catch (error) {
    console.error('Error fetching active URL scan:', error);
    throw error;
  }
};
